import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('div',[_c('DisputeDialogBookingDetails'),_c(VRow,{staticClass:"mb-4"},[_c(VCol,{attrs:{"cols":"12","md":"6"}},[_c('DisputeDialogClientInfoCard')],1),_c(VCol,{attrs:{"cols":"12","md":"6"}},[_c('DisputeDialogCandidateInfoCard')],1)],1),_c('DisputeDialogBookingHistory')],1):_c('Spinner',{staticClass:"mt-10",attrs:{"size":"60"}})}
var staticRenderFns = []

export { render, staticRenderFns }